import { useLocation } from 'react-router-dom';
import { $api } from '@service/RequestService';
import { stringifyUrl } from 'query-string';
import { useMutation } from 'react-query';

export function useDeleteChatflowBlocks() {
  const location = useLocation();
  const segments = location.pathname.split('/');
  const agentId = segments[2];

  return useMutation({
    mutationFn: async (blocks: number[]) => {
      const res = await $api.delete(stringifyUrl({ url: `/v1/chat-flow/block/${agentId}`, query: { blocks } }));

      return res.data;
    }
  });
}
